import React from "react";
import { Card, Typography } from "@mui/material";
import AppButton from "../../../../components/buyer/AppButton";

const SupportSection = ({ onNavigateContact, theme }) => (
  <Card
    sx={{
      p:3,
      borderRadius: 3,
      height: "100%",
      background: "#f0f7ff",
      boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
      border: "1px solid rgba(0,0,0,0.04)",
      "@media (min-width:600px)": {
        p: 4, // Padding adjustment for medium screens
      },
      "@media (min-width:900px)": {
        p: 5, // Padding adjustment for larger screens
      },
    }}
  >
    <Typography variant="h5" fontWeight={600} mb={2} sx={{
        fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Responsive font size
      }}>
      Need Help?
    </Typography>
    <Typography variant="body2" color="text.secondary" mb={2} sx={{
        fontSize: { xs: "0.9rem", sm: "1rem" }, // Adjust font size on small screens
      }}>
      Visit our{" "}
      <a href="/faq" style={{ color: theme.palette.primary.main }}>
        FAQ
      </a>{" "}
      or contact our support team for assistance.
    </Typography>
    <AppButton
      onClick={onNavigateContact}
      style={{
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
        border: "none",
        width: {
          xs: "80%", // Full width on small screens
          sm: "60%", // 60% width on medium screens
          md: "40%", // 40% width on larger screens
        },
        margin: "auto",
      }}
    >
      Contact Support
    </AppButton>
  </Card>
);

export default SupportSection;
